import OrientationIcon from '@ingka/ssr-icon/paths/orientation';
import { Entity, OutlinedComponent, PlacementResult } from '@inter-ikea-core/core';
import { useCore } from 'contexts/core';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import ContextButton from '../ContextButton';
import { reportRotate } from 'analytics/reporters';
import { PlannerCoreApi } from '@inter-ikea-storageone/range';
import { showInfoMessage } from 'ducks/layout';
import { useAppDispatch } from 'ducks/hooks';

const Wrapper = styled.div``;

const DisabledText = styled.div`
  display: none;
  :not(:focus):not(:active) {
    clip: rect(0 0 0 0);
    clip-path: inset(100%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
`;

type Props = {
  selectedEntity: Entity;
  size?: 'xsmall' | 'small' | 'medium';
};

export const rotateAction = (coreApi: PlannerCoreApi, selectedEntity: Entity) => {
  const rotateResult: PlacementResult = coreApi.history.historyAction(() => {
    return coreApi.entities.rotate(selectedEntity);
  });

  if (!rotateResult.valid) {
    coreApi.history.undo();
    coreApi.history.discardLatestSnapshot();
    selectedEntity.addComponent(new OutlinedComponent());
  } else if (rotateResult.placedEntity) {
    coreApi.entities.select(rotateResult.placedEntity);
  }
  return rotateResult;
};

const Rotate = ({ selectedEntity, size }: Props) => {
  const { formatMessage } = useIntl();
  const coreApi = useCore();
  const dispatch = useAppDispatch();

  const onRotateClicked = () => {
    const rotatePlacement = rotateAction(coreApi, selectedEntity);

    !rotatePlacement.valid &&
      dispatch(
        showInfoMessage({
          message: 'storageone.rotateUnavailablePrompt'
        })
      );
    reportRotate();
  };

  return (
    <Wrapper>
      <ContextButton
        label={formatMessage({ id: 'storageone.contextMenuRotate' })}
        dataTestId="rotate"
        onClick={onRotateClicked}
        ssrIcon={OrientationIcon}
        size={size}
      >
        <DisabledText>{formatMessage({ id: 'storageone.contextMenuRotate' })}</DisabledText>
      </ContextButton>
    </Wrapper>
  );
};

export default Rotate;
